var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"wrap-back-top",attrs:{"id":"to-top-btn","href":"javascript:scrollTo(0,0);"}})}
var staticRenderFns = []

export { render, staticRenderFns }